import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, useNavigate, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';

import { createEntity, getEntity, reset, updateEntity } from './catalogo-institucion.reducer';

export const CatalogoInstitucionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const catalogoInstitucionEntity = useAppSelector(state => state.catalogoInstitucion.entity);
  const loading = useAppSelector(state => state.catalogoInstitucion.loading);
  const updating = useAppSelector(state => state.catalogoInstitucion.updating);
  const updateSuccess = useAppSelector(state => state.catalogoInstitucion.updateSuccess);

  const handleClose = () => {
    navigate(`/catalogo-institucion${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    values.createdDate = convertDateTimeToServer(values.createdDate);

    const entity = {
      ...catalogoInstitucionEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
        }
      : {
          ...catalogoInstitucionEntity,
          createdDate: convertDateTimeFromServer(catalogoInstitucionEntity.createdDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tupago1App.catalogoInstitucion.home.createOrEditLabel" data-cy="CatalogoInstitucionCreateUpdateHeading">
            Create or edit a Catalogo Institucion
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew && (
                <ValidatedField name="id" required readOnly id="catalogo-institucion-id" label="ID" validate={{ required: true }} />
              )}
              <ValidatedField
                label="Clave Institucion"
                id="catalogo-institucion-claveInstitucion"
                name="claveInstitucion"
                data-cy="claveInstitucion"
                type="text"
                validate={{
                  minLength: { value: 5, message: 'This field is required to be at least 5 characters.' },
                  maxLength: { value: 5, message: 'This field cannot be longer than 5 characters.' },
                }}
              />
              <ValidatedField
                label="Nombre Corto"
                id="catalogo-institucion-nombreCorto"
                name="nombreCorto"
                data-cy="nombreCorto"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Created Date"
                id="catalogo-institucion-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button
                as={Link as any}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/catalogo-institucion"
                replace
                variant="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button variant="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CatalogoInstitucionUpdate;
